const logger = {
  error: (message, error) => {
    console.error('🔴 Error:', message);
    console.error('Stack:', error?.stack || 'No stack trace');
    console.error('Details:', error);
  },
  
  warn: (message, data = {}) => {
    console.warn('🟡 Warning:', message, data);
  },
  
  info: (message, data = {}) => {
    console.info('🔵 Info:', message, data);
  },
  
  debug: (message, data = {}) => {
    console.debug('🟣 Debug:', message, data);
  }
};

export default logger; 